import { QuestionBase } from './question-base.model';

export class HiddenQuestion extends QuestionBase<string> {
    controlType = 'hidden';

    constructor(options: {} = {}) {
        super(options);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/form/models/question-hidden.model.ts